import { useEffect, useState } from "react"

/**
 * useDebounce hook
 * Delays updating the returned value until after the specified delay has elapsed since the last change.
 *
 * @param value - The value to debounce. For objects/arrays, consider memoizing with useMemo to avoid unnecessary updates.
 * @param delay - Delay in milliseconds. Defaults to 500ms.
 * @returns The debounced value.
 */
export const useDebounce = <T>(value: T, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value)
  
    useEffect(() => {
      const timeout = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
  
      return () => clearTimeout(timeout)
    }, [value, delay])
  
    return debouncedValue
  }